import axios from 'axios';
import { baseUrl } from '@/config';

/**
 * objProduct API
 * @author najongdang
 */
export default {
  /**
   * objtypeId 별 objProduct list를 반환한다
   * @author najongdang
   * @param  {string} objtypeId [objtypeId]
   * @return {array}             objProduct 배열
   */
  getObjProductList(objtypeId) {
    return axios.get(`${baseUrl}/common/obj-product/get-obj-product-list.do`, { params: { objtypeId } });
  },
  /**
   * 벤더의 모델을 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getObjProductListByCompany(params) {
    return axios.get(`${baseUrl}/common/obj-product/get-obj-product-list-by-company.do`, { params });
  },
};



// WEBPACK FOOTER //
// ./src/api/model/obj-product.js